import React from "react";
import * as Tabs from "@radix-ui/react-tabs";
import { useStyles } from "./styles";

export type TabContentProps = React.ComponentProps<typeof Tabs.Content> & {
  variant?: "card" | "page";
};

export function TabContent({
  variant = "page",
  ...rest
}: TabContentProps): JSX.Element {
  const classes = useStyles({ variant, ...rest });

  return (
    <Tabs.Content {...rest} className={classes.root}>
      {rest.children}
    </Tabs.Content>
  );
}
